import { render, staticRenderFns } from "./ResponsibilitiesUnique.vue?vue&type=template&id=33913bee&"
import script from "./ResponsibilitiesUnique.vue?vue&type=script&lang=js&"
export * from "./ResponsibilitiesUnique.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports